'use strict';

/**
 * Disable the event call.
 */
export function _disableEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

export function Init() {
    let _eleLastProduct = document.querySelectorAll('.product-grid__item');
    if (_eleLastProduct.length != 0) {
        _eleLastProduct[_eleLastProduct.length - 1].classList.add('product-gridItem__last');
    }
    $('.product-tile__quickshop-trigger').on('click', function(event) {
        let _ele = $(event.currentTarget),
            _quickshopCloseBtnVisible = $('.product-tile__quickshop-options-close-btn').not('.hidden'),
            _eleProductTile = _ele.parents('.product-tile'),
            _eleProductTileList = _ele.parents('.slick-slider'),
            _eleProductTileSlide = _ele.parents('.slick-slide'),
            _quickshopCloseBtn = _eleProductTile.find('.product-tile__quickshop-options-close-btn'),
            _quickshopOptions = _ele.parents('.product-tile__quickshop').find('.product-tile__quickshop-options');

        _quickshopCloseBtnVisible.click();
        _eleProductTile.addClass('quick-shop-active');
        _ele.addClass('hidden');
        _quickshopOptions.removeClass('hidden');
        _quickshopCloseBtn.removeClass('hidden');
        $('body').addClass('quickshop-dialog-overlay');
        $('body').trigger('product:afterSelectSizeClicked');

        if ($('.quick-shop-active .slick-slider')) {
            $('.quick-shop-active .slick-slider').slick('setPosition');
        }

        if (_eleProductTileList.length > 0) {
            let _slickList = _eleProductTileList.find('.slick-list').first();

            _eleProductTileList.addClass('productlist-quick-shop-active');
            _eleProductTileSlide.addClass('slide-quick-shop-active');
            _slickList.addClass('slicklist-quick-shop-active');
        }

        if ($('.slick-slider')) {
            $('.slick-slider').slick('setPosition');
        }

    })

    $('.product-tile__quickshop-options-close-btn').on('click', function(event) {
        _disableEvent(event);

        let _ele = $(event.currentTarget),
            _eleProductTile = _ele.parents('.product-tile'),
            _eleQuickShopBtn = _eleProductTile.find('.product-tile__quickshop-trigger'),
            _quickshopOptions = _eleProductTile.find('.product-tile__quickshop-options'),
            _eleProductTileList = _ele.parents('.slick-slider'),
            _eleProductTileSlide = _ele.parents('.slick-slide');

        _ele.addClass('hidden');
        _eleProductTile.removeClass('quick-shop-active');
        $('.product-tile__packshots-slide').slick('setPosition');
        _eleQuickShopBtn.removeClass('hidden');
        _quickshopOptions.addClass('hidden');
        $('body').removeClass('quickshop-dialog-overlay');
        $('body').trigger('product:afterQuickShopCloseButtonClicked');

        if (_eleProductTileList.length > 0) {
            let _slickList = _eleProductTileList.find('.slick-list').first();
            _slickList.removeClass('slicklist-quick-shop-active');
            _eleProductTileList.removeClass('productlist-quick-shop-active');
            _eleProductTileSlide.removeClass('slide-quick-shop-active');
        }

        if ($('.slick-slider')) {
            $('.slick-slider').slick('setPosition');
        }
    });
}
